import type { SxProps, Theme } from '@mui/material';

export const statsContainer: SxProps<Theme> = {
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  gap: 2,
};

export const statCard: SxProps<Theme> = {
  flex: 1,
  height: 168,
  minWidth: 250,
  borderRadius: 2,
  border: (theme) => `1px solid ${theme.palette.divider}`,
  backgroundColor: (theme) =>
    theme.palette.mode === 'dark' ? 'transparent' : theme.palette.background.paper,
  background: (theme) =>
    theme.palette.mode === 'dark'
      ? 'linear-gradient(0deg, var(--background-default, #110322) -6.53%, var(--background-paper-elevation-1, #271A35) 123.58%)'
      : undefined,
};

export const cardContent: SxProps<Theme> = {
  padding: 2,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  '&:last-child': {
    paddingBottom: 2,
  },
};

export const valueTypography: SxProps<Theme> = {
  mb: 1,
  fontFamily: 'Space Grotesk, sans-serif',
  fontWeight: 700,
  fontSize: { xs: 32, sm: 40 },
  lineHeight: 1.2,
};

export const labelTypography: SxProps<Theme> = {
  fontFamily: 'Space Grotesk, sans-serif',
  fontWeight: 400,
  fontSize: { xs: 16, sm: 18 },
  lineHeight: 1.5,
};

export const comparisonContainer: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 1,
  mt: 2,
};

export const changeBadgeSuccess: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.success.main,
  color: (theme) => theme.palette.success.contrastText,
  padding: '4px 12px',
  borderRadius: '16px',
  fontFamily: 'Mulish, sans-serif',
  fontSize: '13px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '18px',
  letterSpacing: '0.16px',
  fontFeatureSettings: "'liga' off, 'clig' off",
};

export const changeBadgeError: SxProps<Theme> = {
  borderRadius: '100px',
  backgroundColor: (theme) => theme.palette.error.main,
  color: (theme) => theme.palette.error.contrastText,
  padding: '4px 12px',
  fontFamily: 'Mulish, sans-serif',
  fontSize: '13px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '18px',
  letterSpacing: '0.16px',
  fontFeatureSettings: "'liga' off, 'clig' off",
};

export const comparisonTextTypography: SxProps<Theme> = {
  fontFamily: 'Mulish, sans-serif',
  fontWeight: 400,
  fontSize: { xs: 12, sm: 14 },
  lineHeight: 1.5,
};
